// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
// APOLLO
import { graphql, compose } from 'react-apollo';
import REVOKE_STRIPE_ACCESS from 'ApolloClient/Mutations/revokeStripeAccess';
// ANTD
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import notification from 'antd/lib/notification';
// COMPONENTS
import Button from 'components/common/Button';
import stripeImg from 'lib/media/blue-on-light@2x.png';
import stripeLogo from 'lib/media/Stripe-Logo.svg';

const styles = {
  container: {
    border: '1px solid #efefef',
    borderLeft: '5px solid #6771e6',
    minHeight: 100,
    padding: 15,
    width: 550,
    maxWidth: '100%',
  },
};

const { REACT_APP_STRIPE_CONNECT_KEY, REACT_APP_PUBLIC_URL } = process.env;
const REDIRECT_URI = `${REACT_APP_PUBLIC_URL}app/studio`;
const STRIPE_URL = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${REACT_APP_STRIPE_CONNECT_KEY}&scope=read_write&redirect_uri=${encodeURIComponent(
  REDIRECT_URI,
)}`;

class StripeConnected extends React.PureComponent {
  handleRevoke = async evt => {
    evt.preventDefault();

    const { revokeStripeAccess } = this.props;

    try {
      await revokeStripeAccess({ variables: {} });
    } catch (exc) {
      console.log(exc);
      // Raven.captureException(exc);
      return notification.error({ message: exc });
    }

    notification.success({ message: 'Stripe access revoked!' });
  };

  render() {
    const { stripeUserIdExists } = this.props;

    if (!stripeUserIdExists) {
      return (
        <a href={STRIPE_URL} target="_blank" rel="noopener noreferrer">
          <img alt="stripe" src={stripeImg} style={{ maxHeight: 33, cursor: 'pointer' }} />
        </a>
      );
    }

    return (
      <div>
        <Row type="flex" align="middle" justify="center" style={styles.container}>
          <Col xs={24} sm={16} style={{ display: 'flex', justifyContent: 'flex-start', textAlign: 'left' }}>
            <img src={stripeLogo} alt="logo" style={{ maxHeight: 85 }} />
            {/* <a>DEAUTHORIZE ACCOUNT</a> */}
          </Col>
          <Col xs={24} sm={8} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a target="_blank" href="https://dashboard.stripe.com/">
              <Button size="large" style={{ background: '#6771e6', color: 'white' }}>
                VIEW STRIPE DASHBOARD
              </Button>
            </a>
          </Col>
          <Col xs={24} />
        </Row>
        <a href="" onClick={this.handleRevoke}>
          Revoke HeyNed Access
        </a>
      </div>
    );
  }
}

StripeConnected.propTypes = {
  currentUser: PropTypes.object.isRequired, // eslint-disable-line
  revokeStripeAccess: PropTypes.func.isRequired,
};

const enhance = compose(graphql(REVOKE_STRIPE_ACCESS, { name: 'revokeStripeAccess' }));

export default enhance(StripeConnected);



// WEBPACK FOOTER //
// ./src/routes/app-studio/PaymentsArea/StripeConnected/index.js